import React, { useEffect, useContext, useState } from "react";
import Spinner from "../../layout/Spinner";
import ScreenContext from "../../../context/screen/ScreenContext";
import FlexVideo from "./FlexVideo";
import "./FlexDisplay.css";

const FlexDisplay = () => {
  const screenContext = useContext(ScreenContext);

  const { loading, screen, sendScreenStatus } = screenContext;

  const videos = [
    "https://player.vimeo.com/progressive_redirect/playback/1010004557/rendition/720p/file.mp4?loc=external&signature=06a57cd2464fe4cf1fd8a950e810520e00241bcb72bfb828fa56518cc382eb99",
    "https://player.vimeo.com/progressive_redirect/playback/1135863335/rendition/720p/file.mp4%20%28720p%29.mp4?loc=external&signature=12bfdcd15eb4e2a875cffa1fbf01922b915dbf9339720e6a735e66a22261b4a7",
  ];

  const [month, setMonth] = useState(new Date().getMonth());
  const [flexVideo, setFlexVideo] = useState(videos[month % videos.length]);

  // const flexVideo =
  //   "https://player.vimeo.com/progressive_redirect/playback/1135863335/rendition/720p/file.mp4%20%28720p%29.mp4?loc=external&signature=12bfdcd15eb4e2a875cffa1fbf01922b915dbf9339720e6a735e66a22261b4a7";

  useEffect(() => {
    // set a 60 second timer
    const interval = setInterval(() => {
      // send screen status update & check if workout should update
      if (screen) sendScreenStatus(screen.id);
    }, 60 * 1000);

    return () => clearInterval(interval);

    // eslint-disable-next-line
  });

  useEffect(() => {
    const interval = setInterval(
      () => {
        const newMonth = new Date().getMonth();
        if (newMonth !== month) {
          setMonth(newMonth);
          setFlexVideo(videos[newMonth % videos.length]);
        }
      },
      1000 * 60 * 60,
    );
    return () => clearInterval(interval);
  }, [month]);

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <div className="FlexDisplay">
          <FlexVideo flexVideo={flexVideo} />
        </div>
      )}
    </>
  );
};

export default FlexDisplay;
